import React, { useState, useEffect, useRef } from 'react';
import flatpickr from 'flatpickr';
import 'flatpickr/dist/flatpickr.min.css';
import { FaCalendar, FaClock } from 'react-icons/fa';
import './demoform.css';
import Success from '../../../assets/images/im_Success.png';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import moment from 'moment';
import { ClientPreLoginService } from '../../../services/clientPreLoginService';
const Demoform = () => {
  const [popupVisible, setPopupVisible] = useState(false);
  const datePickerRef = useRef(null);
  const [dateTime, setDateTime] = useState('');
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobile: "",
    email: "",
    company: "",
  });
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const location = useLocation();
  useEffect(() => {
    if (datePickerRef.current) {
      if (datePickerRef.current._flatpickr) {
        datePickerRef.current._flatpickr.destroy();
      }

      const fp = flatpickr(datePickerRef.current, {
        enableTime: true,
        dateFormat: "d-m-Y H:i",
        noCalendar: false,
        disableMobile: true,
        altInput: false,
        allowInput: true,
        defaultDate: "",
        onReady: function (selectedDates, dateStr, instance) {
          setTimeout(() => {
            instance.input.placeholder = "";
            instance.input.removeAttribute("placeholder");
          }, 10);
        },
        onChange: (selectedDates, dateStr) => {
          setDateTime(dateStr);
          setErrors((prevErrors) => ({ ...prevErrors, dateTime: "" }));
        },
        onClose: () => {
          datePickerRef.current.blur();
        },
      });

      return () => {
        fp.destroy();
      };
    }
  }, []);


  useEffect(() => {
    if (datePickerRef.current) {
      setTimeout(() => {
        datePickerRef.current.value = "";
        datePickerRef.current.placeholder = "";
        datePickerRef.current.removeAttribute("placeholder");
      }, 100);
    }
  }, []);

  const namePattern = /^[A-Za-z\s]+$/;
  const mobilePattern = /^\+?[0-9]{1,3}[0-9]{10}$/;
  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;

  const validateField = (name, value) => {
    let error = "";
    if (name === "firstName" || name === "lastName" || name === "company") {
      if (!value.trim()) {
        error = `${name.replace(/([A-Z])/g, " $1")} is required`;
      } else if (!namePattern.test(value)) {
        error = `${name.replace(/([A-Z])/g, " $1")} must contain only letters`;
      }
    } else if (name === "mobile") {
      if (!value.trim()) {
        error = "Mobile number is required";
      } else if (!mobilePattern.test(value)) {
        error = "Enter a valid 10-digit mobile number (e.g., +919876543210)";
      }
    } else if (name === "email") {
      if (!value.trim()) {
        error = "Email is required";
      } else if (!emailPattern.test(value)) {
        error = "Enter a valid email address";
      }
    } else if (name === "dateTime") {
      if (!value) {
        error = "Appointment Date & Time is required";
      }
    }
    return error;
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: validateField(name, value) });
  };

  const handleRequestDemo = async () => {
    const newErrors = {};
    Object.keys(formData).forEach((key) => {
      newErrors[key] = validateField(key, formData[key]);
    });
    newErrors.dateTime = validateField("dateTime", dateTime);

    setErrors(newErrors);

    const formattedDateTime = moment(dateTime, "DD-MM-YYYY HH:mm").format("YYYY-MM-DDTHH:mm:ss.SSSZ");

    const requestBody = {
      firstName: formData.firstName,
      lastName: formData.lastName,
      mobileNo: formData.mobile,
      emailId: formData.email,
      companyName: formData.company,
      appointmentDtTime: formattedDateTime,
    };

    try {
      const response = await ClientPreLoginService.requestDemo(requestBody);
      setPopupVisible(true);
    } catch (error) {
      console.error("Demo request failed:", error);
    }
  };

  const openDatePicker = () => {
    if (datePickerRef.current?._flatpickr) {
      datePickerRef.current._flatpickr.open();
    }
  };

  const openTimePicker = () => {
    if (datePickerRef.current?._flatpickr) {
      datePickerRef.current._flatpickr.set("enableTime", true);
      datePickerRef.current._flatpickr.set("noCalendar", true);
      datePickerRef.current._flatpickr.open();
    }
  };
  useEffect(() => {
    const savedScrollPosition = sessionStorage.getItem("scrollPosition");
    if (savedScrollPosition) {
      window.scrollTo(0, parseInt(savedScrollPosition, 10));
    }
  }, []);

  return (
    <>
      <div className="fluid-container">
        <div className=" demo-row row">
          <div className="col-lg-6" style={{ paddingLeft: '120px' }}>
            <div className='demo-breadcrumb'>
              <span style={{ color: '#F35824', fontWeight: '600', textDecoration: 'none', marginRight: '50px' }}>
                <span
                  style={{ color: "#F35824", textDecoration: "none", cursor: "pointer" }}
                  onClick={() => navigate(-1)}
                >
                  Back
                </span>
                <span style={{ marginLeft: '10px' }}> /</span>
                <span style={{ marginLeft: '10px' }}> Demo</span>
              </span>
            </div>
            <h2 className="section-heading">EXPERIENCE LEADERLY LIVE</h2>
            <div className="form-fields">
              <div className="demo-row-form-row">
                <div className="col-md-6">
                  <div className="input-group">
                    <label htmlFor="first-name">First Name*</label>
                    <input
                      id="first-name"
                      name="firstName"
                      type="text"
                      value={formData.firstName}
                      onChange={handleInputChange}
                      className={errors.firstName ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.firstName && <span className="error-text">{errors.firstName}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-group">
                    <label htmlFor="last-name">Last Name*</label>
                    <input
                      id="last-name"
                      name="lastName"
                      type="text"
                      value={formData.lastName}
                      onChange={handleInputChange}
                      className={errors.lastName ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.lastName && <span className="error-text">{errors.lastName}</span>}
                  </div>
                </div>
              </div>
              <div className="demo-row-form-row">
                <div className="col-md-6">
                  <div className="input-group">
                    <label htmlFor="mobile">Mobile*</label>
                    <input
                      id="mobile"
                      name="mobile"
                      type="tel"
                      value={formData.mobile}
                      onChange={handleInputChange}
                      className={errors.mobile ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.mobile && <span className="error-text">{errors.mobile}</span>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="input-group">
                    <label htmlFor="email">Email Id*</label>
                    <input
                      id="email"
                      name="email"
                      type="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      className={errors.email ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.email && <span className="error-text">{errors.email}</span>}
                  </div>
                </div>
              </div>
              <div className="demo-row-form-row">
                <div className="col-md-6">
                  <div className="input-group">
                    <label htmlFor="company">Company*</label>
                    <input
                      id="company"
                      name="company"
                      type="text"
                      value={formData.company}
                      onChange={handleInputChange}
                      className={errors.company ? "input-error" : ""}
                      style={{ paddingLeft: "12px" }}
                      spellCheck="false"
                    />
                    {errors.company && <span className="error-text">{errors.company}</span>}
                  </div>
                </div>
              </div>
              <div className="demo-row-form-row">
                <div className="col-md-11">
                  <div className="input-group">
                    <label htmlFor="appointment">Appointment Date & Time*</label>
                    <div style={{ position: 'relative' }}>
                      <input
                        id="appointment-date-time"
                        ref={datePickerRef}
                        type="text"
                        className={`form-control datetimepicker-input ${errors.dateTime ? "input-error" : ""}`}
                        style={{ paddingRight: '40px', marginBottom: '10px', background: 'rgba(255, 255, 255, 1)', width: '100%', boxShadow: 'none' }}
                        readOnly
                        value={dateTime}
                      />
                      <FaCalendar
                        onClick={openDatePicker}
                        style={{
                          position: 'absolute',
                          left: 'calc(100% - 80px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                        }}
                      />
                      <FaClock
                        onClick={openTimePicker}
                        style={{
                          position: 'absolute',
                          left: 'calc(100% - 50px)',
                          top: '50%',
                          transform: 'translateY(-50%)',
                          cursor: 'pointer',
                        }}
                      />
                    </div>
                    {errors.dateTime && <span className="error-text">{errors.dateTime}</span>}
                  </div>
                </div>
              </div>

              <button className="request-demo-btn" onClick={handleRequestDemo}>
                Request a Demo
              </button>
            </div>
          </div>

          <div
            className="col-lg-6 demo"
            style={{ background: 'linear-gradient(183.88deg, #2F2F2F -24.77%, #000000 71.42%)' }}
          >
            <div className='demo-contents'>
              <h2 className="section1-heading">Schedule a Demo</h2>
              <p className="descriptions">
                Discover the power of a personalised live demo, receive tailored answers to your questions, and unlock why
                Leaderly is the perfect fit for your organization.
              </p>
              <ul className="demo-points">
                <li>
                  <span className="tickmark-1">
                    <i className="fas fa-check"></i>
                  </span>{' '}
                  A brief conversation to discuss your hiring needs, and discover how Leaderly can help you build a robust
                  talent pool and connect with ideal senior management candidates.
                </li>
                <li>
                  <span className="tickmark-1">
                    <i className="fas fa-check"></i>
                  </span>{' '}
                  A live platform demo that gives an immersive experience with access to all features.
                </li>
                <li>
                  <span className="tickmark-1">
                    <i className="fas fa-check"></i>
                  </span>{' '}
                  Get detailed answers to all your queries immediately.
                </li>
                <li>
                  <span className="tickmark-1">
                    <i className="fas fa-check"></i>
                  </span>{' '}
                  Explore the platform firsthand, no commitments are required.
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      {popupVisible && (
        <div className="popup-overlay">
          <div className="popup-content">
            <button className="close-button" onClick={() => setPopupVisible(false)}>
              <i className="fa fa-times" aria-hidden="true"></i>
            </button>
            <img src={Success} alt="success logo" className="success-logo" />
            <h3>Demo Successfully Booked</h3>
            <p>A customer care representative will get back to you</p>
          </div>
        </div>
      )}
      <style>
        {`
          .error-text {
            color: red;
            font-size: 12px;
            margin-top: 5px;
            display: block;
          }
          .input-error {
            border-color: red;
          }
        `}
      </style>
    </>
  );
};

export default Demoform;